<template>
    <div v-if="confirmType == 0" style="padding:20px">
        <!--- purchase new license ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" style="width: 30%" v-t="'message.item_planType'">
                </td>
                <td class="license-item-title" style="text-align:right;width: 30%" v-t="'message.item_purchase_count'">
                </td>
                <td colspan="2" class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_amount'">
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ getDisplayPlanName(newPlanType) }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.newValue }}
                </td>
                <td colspan="2" class="license-item-value" style="text-align: right;width: 80px;padding-right: 10px">
                    {{ getDisplayAmountValue(getNewAmount()) }}
                </td>
            </tr>
        </table>
    </div>
    <div v-else-if="confirmType == 1" style="padding:20px">
        <!--- change purchased license ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_planType'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.item_current_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:25px" v-t="'message.item_changed_purchase_count'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="isMonthlyContract()" v-t="'message.item_purchase_current_amount'"></span>
                    <span v-else v-t="'message.item_purchase_next_amount'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="isMonthlyContract()" v-t="'message.item_purchase_next_amount'"></span>
                    <span v-else v-t="'message.item_purchase_additional_amount'"></span>
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ getDisplayPlanName(planType) }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.newValue }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    <span v-if="isMonthlyContract()">{{ getDisplayAmountValue(getCurrentAmount()) }}</span>
                    <span v-else>{{ getDisplayAmountValue(getNewAmount()) }}</span>
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="isMonthlyContract()">{{ getDisplayAmountValue(getNewAmount()) }}</span>
                    <span v-else>{{ getDisplayAmountValue(getAdditionalAmountTotal()) }}</span>
                </td>
            </tr>
        </table>
    </div>
    <div v-else-if="confirmType == 2" style="padding:20px">
        <!--- change contract term ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.item_planType'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_purchased_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_renewal_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="isMonthlyContract()" v-t="'message.item_amount_monthly'"></span>
                    <span v-else v-t="'message.item_amount_yearly'"></span>
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px">
                    <span v-if="isMonthlyContract()" v-t="'message.item_amount_yearly'"></span>
                    <span v-else v-t="'message.item_amount_monthly'"></span>
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ getDisplayPlanName(planType) }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.currentMax }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    {{ getDisplayAmountValue(getCurrentAmount()) }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    {{ getDisplayAmountValue(getNewAmount()) }}
                </td>
            </tr>
        </table>
    </div>
    <div v-else style="padding:20px">
        <!--- change plan type ---->
        <table width="100%">
            <tr class="license-record-header">
                <td class="license-item-title" v-t="'message.title_current_plan'">
                </td>
                <td class="license-item-title" v-t="'message.title_modified_plan'">
                </td>
                <td class="license-item-title" style="text-align:right;padding-right:25px" v-t="'message.title_purchased_number_of_licenses'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_purchase_next_amount'">
                </td>
                <td class="license-item-title" style="text-align: right;padding-right:10px" v-t="'message.item_plan_upgrade_amount'">
                </td>
            <tr>
            <tr class="license-record-no-hover-bottom">
                <td class="license-item-value">
                    {{ getDisplayPlanName(planType) }}
                </td>
                <td class="license-item-value">
                    {{ getDisplayPlanName(newPlanType) }}
                </td>
                <td class="license-item-value" style="text-align: right">
                    {{ licenseInfo.pastMax }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 10px">
                    {{ getDisplayAmountValue(getNewAmount()) }}
                </td>
                <td class="license-item-value" style="text-align: right;padding-right: 20px">
                    <span v-if="upgradePlanType < 0">N/A</span>
                    <span v-else>{{ getDisplayAmountValue(getAdditionalAmountTotal()) }}</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            Const: {
                PURCHASE_PERIOD_MONTHLY: constants.PURCHASE_PERIOD_MONTHLY,
                PURCHASE_PERIOD_YEARLY: constants.PURCHASE_PERIOD_YEARLY
            }
        };
    },
    methods: {
        getNewAmount() {
            let numberOfLicense;
            let amount;
            if ((this.confirmType == 0) || (this.confirmType == 1)) {
               numberOfLicense = this.licenseInfo.newValue;
            } else {
               numberOfLicense = this.licenseInfo.currentMax;
            }
            if (this.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                if (this.changePurchasePeriodType) {
                    amount = numberOfLicense * this.priceNewPlan.yearPrice * 12;
                } else {
                    amount = numberOfLicense * this.priceNewPlan.monthPrice;
                }
            } else {
                if (this.changePurchasePeriodType) {
                    amount = numberOfLicense * this.priceNewPlan.monthPrice;
                } else {
                    amount = numberOfLicense * this.priceNewPlan.yearPrice * 12;
                }
            }
            amount += (amount * this.appData.taxRate);
            if (this.currencyYen) {
                return Math.ceil(amount);
            } else {
                return Math.ceil(amount*100) / 100;
            }
        },
        getCurrentAmount() {
            let amount;
            if (this.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                amount = Math.max(this.licenseInfo.pastMax, this.licenseInfo.newValue) * this.priceOfPlan.monthPrice;
            } else {
                amount = this.licenseInfo.pastMax * this.priceOfPlan.yearPrice * 12;
            }
            amount += (amount * this.appData.taxRate);
            if (this.currencyYen) {
                return Math.ceil(amount);
            } else {
                return Math.ceil(amount*100) / 100;
            }
        },
        getAdditionalAmountTotal() {
            let amount = 0;
            if (this.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                amount = Number(this.licenseInfo.pastMax * this.priceUpgradePlan.monthPrice);
            } else {
                if (this.planType == this.newPlanType) {
                    if (this.licenseInfo.newValue > this.licenseInfo.pastMax) {
                        amount = Number((this.licenseInfo.newValue - this.licenseInfo.pastMax) * this.priceNewPlan.yearPrice * 12 * commonUtil.getBillableRate(this.appData.basicContract.nextFlushDatetime));
                    }
                } else {
                    amount = Number(this.licenseInfo.pastMax * this.priceUpgradePlan.yearPrice * 12 * commonUtil.getBillableRate(this.appData.basicContract.nextFlushDatetime));
                }
            }
            amount += (amount * this.appData.taxRate);
            if (this.currencyYen) {
                return Math.ceil(amount);
            } else {
                return Math.ceil(amount*100) / 100;
            }
        },
        getUnitPrice(licenseType) {
            for (let price of this.priceList) {
                if (price.type == licenseType) {
                    return price;
                }
            }
        },
        getDisplayAmountValue(amount) {
            if (this.currencyYen) {
                return Number(amount).toLocaleString();
            } else {
                return Number(amount).toFixed(2).toLocaleString();
            }
        },
        getDisplayPlanName(planType) {
            return commonUtil.getPlanName(planType);
        },
        isMonthlyContract() {
            return (this.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY)
        }
    },
    components: {
    },
    created: function() {
    },
    computed: {
        changePurchasePeriodType: function() {
            if ((this.appData.basicContract.purchasePeriodType == this.purchasePeriodType) || (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) || (this.confirmType == 0)) {
                return false;
            } else {
                return true;
            }
        }
    },
    props: [ 'appData' , 'licenseInfo' , 'purchasePeriodType' , 'confirmType' , 'currencyYen' , 'planType' , 'newPlanType' , 'upgradePlanType' , 'priceOfPlan' , 'priceNewPlan' , 'priceUpgradePlan' ]
}
</script scoped>
<style scoped>

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    max-height: calc(80vh - 290px);
    overflow: auto;
}

.license-item-value >>> .el-input-number {
    width: 160px;
}

.item >>> .el-popper[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff;
}

</style scoped>
